// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vw_a bhc_b bhc_wb"};